import FindClassesPage from './FindClassesPage';

const CategoryClassesPage = () => {
  return <FindClassesPage section="category" official={true} />;
}

export default CategoryClassesPage;